import React from 'react';
import PropTypes from 'prop-types';
import SHGoogleMap from 'search/map/SHGoogleMap';
import EnvironmentUtils from '@spothero/utils/environment';
import {getWindow} from 'ssr-window';
import withConfig from 'config/withConfig';

const window = getWindow();
const isBrowser = EnvironmentUtils.isBrowser();
const gmaps = isBrowser ? window.google.maps : null;

function Map({destination: {title, latitude, longitude}, staticBaseUrl}) {
    return (
        <SHGoogleMap
            destination={{
                title,
                position: isBrowser
                    ? new gmaps.LatLng(latitude, longitude)
                    : null,
            }}
            mapOptions={{
                disableDefaultUI: true,
                zoomControl: false,
                scrollwheel: false,
                draggable: false,
                mapTypeId: isBrowser ? gmaps.MapTypeId.ROADMAP : null,
            }}
            staticBaseUrl={staticBaseUrl}
        />
    );
}

Map.propTypes = {
    destination: PropTypes.shape({
        title: PropTypes.string.isRequired,
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
    }).isRequired,
    staticBaseUrl: PropTypes.string.isRequired,
};

export default withConfig(['staticBaseUrl'])(Map);
